module.exports = __webpack_public_path__ + "static/media/mojo1.d0b28ad6.webp";